import axios from 'axios';
import moment from 'moment/moment';
import React, { useState,useEffect } from 'react'
import { getAttendanceApi} from '../APIURL';
import Table from 'react-bootstrap/Table';

const Attendtabledata = () => {
  const [Data, setData]=useState([])
  const getData=()=>{
    axios.get(getAttendanceApi)
    .then((res) => {
         if (res.data !== null) {
          setData(res.data)
        }
      })
      .catch((err) => {
        alert("Failed to record your attendance, try again")
        console.log(err)
      })

  }

  useEffect(() => {
    getData()
  }, [])
  

  return (

    <div className='container'>
    <div className="row">
    <h1 style={{textAlign:'center'}}>Present Students</h1>
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>Sr.no</th>
          <th>Roll No</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
      {
        Data.map((item)=>{

            return(
                <tr key={item.id}>
          <td>{item.id}</td>
          <td>{item.rollno}</td>
          <td>{item.adate}</td>
        </tr>
            )
        })
      }
        
      </tbody>
    </Table>
    </div>
    </div>

  )
}

export default Attendtabledata